module.exports = __webpack_public_path__ + "img/ikas50px.c9d34086.jpg";